import Resource from './Resource.vue';

const components = [
  Resource,
];

export default components;



// WEBPACK FOOTER //
// ./src/components/resources/index.js